<template>
    <v-container fluid>
        <page-tool-bar show_search :loading="loader" :search.sync="search">
            <v-flex xs12 md2>
                <div style="max-width: 290px" class="mr-3">
                    <v-menu :close-on-content-click="false" v-model="menu_month_picker" :nudge-right="40" lazy
                        transition="scale-transition" offset-y full-width min-width="290px" max-width="290px"
                        :disabled="loader">
                        <v-text-field slot="activator" v-model="chosen_month" label="Chọn tháng" :disabled="loader"
                            prepend-icon="event" readonly hide-details></v-text-field>
                        <v-date-picker locale="vi-VI" type="month" v-model="chosen_month" :min="'2025-06'"
                            @input="menu_month_picker = false"></v-date-picker>
                    </v-menu>
                </div>
            </v-flex>
            <v-flex xs12 md2>
                <div class="text-right d-flex align-center">
                    <v-select v-model="billType" :items="['Điện', 'Nước']" label="Chọn loại hóa đơn" outlined dense
                        hide-details class="mr-3"></v-select>
                </div>
            </v-flex>

            <v-flex shrink>
                <div class="text-right">
                    <v-btn @click="exportAllTablesToCSV" color="primary" dark>XUẤT EXCEL</v-btn>
                </div>
            </v-flex>
        </page-tool-bar>

        <h3 class="mt-4 text-center font-weight-bold">BẢNG PHÂN TÍCH CHI TIẾT</h3>

        <v-layout justify-center align-center v-if="loader" style="min-height:200px"><v-progress-circular indeterminate color="primary" size="50" /></v-layout>
        <template v-else>
            <table-phan-tich-dien-nuoc-chi-tiet :headers="headersTable" :items="itemsTable1"
                :title="tableTitles[0]"
                @update-notes="updateNotes" />
            <table-phan-tich-dien-nuoc-chi-tiet :headers="headersTable" :items="itemsTable2"
                :title="tableTitles[1]"
                @update-notes="updateNotes" />
            <table-phan-tich-dien-nuoc-chi-tiet :headers="headersTable" :items="itemsTable3"
                :title="tableTitles[2]"
                @update-notes="updateNotes" />
            <table-phan-tich-dien-nuoc-chi-tiet :headers="headersTable" :items="itemsTable4"
                :title="tableTitles[3]"
                @update-notes="updateNotes" />
        </template>
    </v-container>
</template>

<script>
import TablePhanTichDienNuocChiTiet from './TablePhanTichDienNuocChiTiet.vue';
import moment from 'moment';
import api from 'Api';
import { buildParamQuery } from 'Helpers';

export default {
    name: 'phan-tich-dien-nuoc-chi-tiet-layout',
    components: {
        TablePhanTichDienNuocChiTiet,
    },
    data() {
        return {
            reload_table: 0,
            download_csv_count: 0,
            loader: false,
            search: "",
            billType: 'Điện',
            chosen_month: moment().format('YYYY-MM'),
            menu_month_picker: false,
            itemsTable1: [],
            itemsTable2: [],
            itemsTable3: [],
            itemsTable4: [],
            devicesMap: {},
        };
    },
    computed: {
        headersTable() {
            const prevMonth = moment(this.chosen_month, 'YYYY-MM').subtract(1, 'month').month() + 1;
            const currMonth = moment(this.chosen_month, 'YYYY-MM').month() + 1;
            return [
                { text: 'Số thứ tự', value: 'stt', align: 'center', sortable: false },
                { text: 'Toà nhà', value: 'building', align: 'center', sortable: false },
                { text: 'Phòng', value: 'room', align: 'center', sortable: false },
                { text: `Tiêu thụ T${prevMonth}`, value: 'previous_month_consumption', align: 'center', sortable: false },
                { text: `Tiêu thụ T${currMonth}`, value: 'consumption', align: 'center', sortable: false },
                { text: 'Trung bình', value: 'average_consumption', align: 'center', sortable: false },
                { text: 'Giải thích', value: 'reason', align: 'center', sortable: false },
                { text: 'Số người', value: 'quantity', align: 'center', sortable: false },
                { text: 'Thiết bị sử dụng', value: 'equipment', align: 'center', sortable: false },
            ];
        },
        headersTable1() {
            const prevMonth = moment(this.chosen_month, 'YYYY-MM').subtract(1, 'month').month() + 1;
            const currMonth = moment(this.chosen_month, 'YYYY-MM').month() + 1;
            return [
                { text: 'Số thứ tự', value: 'stt', align: 'center', sortable: false },
                { text: 'Toà nhà', value: 'building', align: 'center', sortable: false },
                { text: 'Phòng', value: 'room', align: 'center', sortable: false },
                { text: `Tiêu thụ T${prevMonth}`, value: 'previous_month_consumption', align: 'right', sortable: false },
                { text: `Tiêu thụ T${currMonth}`, value: 'consumption', align: 'right', sortable: false },
                { text: 'Trung bình', value: 'average_consumption', align: 'right', sortable: false },
                { text: 'Giải thích', value: 'reason', align: 'left', sortable: false },
                { text: 'Số người', value: 'quantity', align: 'right', sortable: false },
                { text: 'Thiết bị sử dụng', value: 'equipment', align: 'left', sortable: false },
            ];
        },
        headersTable2() { return this.headersTable1; },
        headersTable3() { return this.headersTable1; },
        headersTable4() { return this.headersTable1; },
        date_start_computed() {
            if (!this.chosen_month) return '';
            
            if (this.billType === 'Điện') {
                return `${this.chosen_month}-01`;
            } else {
                const previousMonth = moment(this.chosen_month, 'YYYY-MM').subtract(1, 'month').format('YYYY-MM');
                return `${previousMonth}-12`;
            }
        },
        date_end_computed() {
            if (!this.chosen_month) return '';
            
            if (this.billType === 'Điện') {
                const [year, month] = this.chosen_month.split('-').map(Number);
                const lastDay = new Date(year, month, 0).getDate();
                return `${this.chosen_month}-${String(lastDay).padStart(2, '0')}`;
            } else {
                return `${this.chosen_month}-11`;
            }
        },
        tableTitles() {
            if (this.billType === 'Điện') {
                return [
                    '1/ Các phòng tiêu thụ điện trong tháng bằng 0',
                    '2/ Các phòng chênh lệch cao so với tháng trước',
                    '3/ Các phòng có số tiêu thụ lớn >=250kWh',
                    '4/ Các phòng có số tiêu thụ nhỏ <50kWh, sử dụng TL, MG, ML',
                ];
            } else {
                return [
                    '1/ Các phòng có tiêu thụ nước trong tháng bằng 0',
                    '2/ Các phòng chênh lệch cao so với tháng trước',
                    '3/ Các phòng có số tiêu thụ lớn >=20 khối',
                    '4/ Các phòng có số tiêu thụ nhỏ <5 khối và trên 2 người',
                ];
            }
        },
        rooms() {
            return this.$store.state.app.rooms;
        }
    },
    mounted() {
        this.getData();
    },
    watch: {
        chosen_month() { this.getData(); },
        billType() { this.getData(); },
        search() { this.reload_table++; },
    },
    methods: {
        async getData() {
            this.loader = true;
            try {
                const params = { 
                    month: this.chosen_month,
                    date_start: this.date_start_computed,
                    date_end: this.date_end_computed,
                };
                const query = buildParamQuery(params);
                let res, devicesRes;
                if (this.billType === 'Điện') {
                    res = await api.getElectricityConsumptionAnalysis(query);
                    devicesRes = await api.getUtilityConsumptionAnalysisDevice(query);
                } else {
                    res = await api.getWaterConsumptionAnalysis(query);
                    devicesRes = await api.getUtilityConsumptionAnalysisDevice(query);
                }
                const data = res.data.filter(item => this.rooms.find(room => room.room_id === item.room_id));
                const devices = devicesRes.data || devicesRes;
                this.devicesMap = {};
                devices.forEach(d => {
                    this.devicesMap[`${d.building}_${d.room_id}`] = d.devices;
                });
                this.processData(data);
            } catch (e) {
                this.itemsTable1 = [];
                this.itemsTable2 = [];
                this.itemsTable3 = [];
                this.itemsTable4 = [];
            }
            this.loader = false;
        },
        processData(data) {
            this.itemsTable1 = [];
            this.itemsTable2 = [];
            this.itemsTable3 = [];
            this.itemsTable4 = [];
            let arr1 = [], arr2 = [], arr3 = [], arr4 = [];
            data.forEach(item => {
                const key = `${item.building}_${item.room_id}`;
                const mapped = {
                    building: item.building,
                    room: item.room_id,
                    previous_month_consumption: item.previous_month_consumption || '',
                    consumption: item.consumption || '',
                    average_consumption: item.average_consumption || '',
                    reason: item.notes || '',
                    quantity: item.customer_count || '',
                    equipment: Array.isArray(this.devicesMap[key]) ? this.devicesMap[key].join(', ') : '',
                    _id: item._id,
                };
                if (this.billType === 'Điện') {
                    if (item.zero_consumption_count) arr1.push({ ...mapped });
                    if (item.previous_month_high_difference_count || item.previous_month_high_difference_count) arr2.push({ ...mapped });
                    if (item.high_consumption_count) arr3.push({ ...mapped });
                    if (item.low_consumption_high_occupancy_count) arr4.push({ ...mapped });
                } else {
                    if (item.zero_consumption_count) arr1.push({ ...mapped });
                    if (item.previous_month_high_difference_count || item.previous_month_high_difference_count) arr2.push({ ...mapped });
                    if (item.high_consumption_count) arr3.push({ ...mapped });
                    if (item.low_consumption_high_occupancy_count) arr4.push({ ...mapped });
                }
            });
            const sortFn = (a, b) => {
                if (a.building < b.building) return -1;
                if (a.building > b.building) return 1;
                if (a.room < b.room) return -1;
                if (a.room > b.room) return 1;
                return 0;
            };
            arr1.sort(sortFn); arr2.sort(sortFn); arr3.sort(sortFn); arr4.sort(sortFn);
            arr1.forEach((item, idx) => item.stt = idx + 1);
            arr2.forEach((item, idx) => item.stt = idx + 1);
            arr3.forEach((item, idx) => item.stt = idx + 1);
            arr4.forEach((item, idx) => item.stt = idx + 1);
            this.itemsTable1 = arr1;
            this.itemsTable2 = arr2;
            this.itemsTable3 = arr3;
            this.itemsTable4 = arr4;
        },
        async updateNotes(item, newNotes) {
            try {
                const postData = {
                    room_id: item.room,
                    month: this.chosen_month,
                    building: item.building,
                    notes: newNotes,
                };
                if (this.billType === 'Điện') {
                    await api.updateElectricityConsumptionAnalysis(postData);
                } else {
                    await api.updateWaterConsumptionAnalysis(postData);
                }
                [this.itemsTable1, this.itemsTable2, this.itemsTable3, this.itemsTable4].forEach(table => {
                    table && table.forEach(tableItem => {
                        if (tableItem.room === item.room) {
                            tableItem.reason = newNotes;
                        }
                    });
                });
            } catch (e) {}
        },
        exportAllTablesToCSV() {
            const tablesData = [
                { title: this.tableTitles[0], items: this.itemsTable1 },
                { title: this.tableTitles[1], items: this.itemsTable2 },
                { title: this.tableTitles[2], items: this.itemsTable3 },
                { title: this.tableTitles[3], items: this.itemsTable4 },
            ];
            let csvContent = '';
            csvContent += 'BẢNG PHÂN TÍCH CHI TIẾT\n\n';
            const headers = this.headersTable;
            tablesData.forEach(table => {
                csvContent += `"${table.title}"\n`;
                const headerRow = headers.map(h => `"${h.text}"`).join(',');
                csvContent += headerRow + '\n';
                table.items.forEach(item => {
                    const row = headers.map(header => {
                        let value = item[header.value];
                        if (header.value === 'reason') value = item.notes || item.reason || '';
                        if (value === null || value === undefined) value = '';
                        return `"${String(value).replace(/"/g, '""')}"`;
                    }).join(',');
                    csvContent += row + '\n';
                });
                csvContent += '\n';
            });
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const fileName = `Phan_Tich_Chi_Tiet_Dien_Nuoc_${new Date().toLocaleDateString('vi-VN').replace(/\//g, '-')}.csv`;
            const link = document.createElement('a');
            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', fileName);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                window.open('data:text/csv;charset=utf-8,' + encodeURIComponent(csvContent));
            }
        },
    },
};
</script>

<style scoped>
.text-xs-center {
    text-align: center;
}

.text-xs-right {
    text-align: right;
}
</style>